/**
 * WordPress ships React as `wp.element`, so the bundle borrows it instead of
 * shipping a second copy. Everything below is re-exported so components can
 * `import { useState } from './wp'` and read like ordinary React.
 */
const element = window.wp && window.wp.element;

if (!element) {
    // eslint-disable-next-line no-console
    console.error('[tsa-chrome] wp.element is missing — the header/footer cannot mount.');
}

export const {
    createElement,
    createPortal,
    Fragment,
    useState,
    useEffect,
    useRef,
    useMemo,
    useCallback,
    useLayoutEffect,
} = element || {};

/**
 * Renders children at the end of <body>.
 *
 * The theme animates the sticky header with a transform, which makes it the
 * containing block for any `position: fixed` descendant — full-screen drawers
 * rendered inside the header would be clipped to the header's own box.
 *
 * @param {Object} props
 * @return {Object} portal
 */
export function Portal({ children }) {
    return createPortal(children, document.body);
}

/**
 * createRoot landed in wp.element with WP 6.2; render() is the fallback.
 *
 * @param {HTMLElement} container
 * @param {Object}      node
 */
export function mount(container, node) {
    if (!container) {
        return;
    }

    if (element.createRoot) {
        element.createRoot(container).render(node);
        return;
    }

    element.render(node, container);
}
